import React, { useState } from "react";

import VehicleRegistrationList from "./VehicleRegistrationList";
import VehicleRegistrationForm from "./VehicleRegistrationForm";

const VehicleRegistration = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <VehicleRegistrationForm
          addForm={setFromIsShown}
          update={upData}
          sId={serviceId}
        />
      ) : (
        <VehicleRegistrationList
          addForm={setFromIsShown}
          update={setUpData}
          sId={setServiceId}
        />
      )}
    </>
  );
};

export default VehicleRegistration;
